module.exports = __webpack_public_path__ + "static/media/money.8202a94f.svg";